<h2 mat-dialog-title class="dialog-title">
  {{ data.titulo }}
</h2>

<mat-dialog-content class="dialog-content">
  <span><i>Começa {{ data.date_start | date : "dd/MM/yyyy" }} às {{ formatTime(data.time_start) }}</i></span>
  <p><strong>Tipo:</strong> {{ data.type === 'true' ? 'Entrevista Remota' : 'Entrevista Presencial' }}</p>

  <p *ngIf="data.type === 'false'"><strong>Local:</strong> {{ data.address }}</p>

  <p><strong>Falar com:</strong> {{ data.contact }}</p>

  <ng-container *ngIf="data.link_meet && data.accept == 1">
    <span>
      <strong>Link da Entrevista Online:</strong>
      <a [href]="data.link_meet" target="_blank" rel="noopener noreferrer"
         (click)="checkDateAndConfirm($event, data.date_start, data.time_start)">
        <button mat-icon-button color="primary" matTooltip="Acesse agora clicando aqui!">
          <mat-icon>videocam</mat-icon>
        </button>
      </a>
    </span>
  </ng-container>

  <ng-container *ngIf="data.accept === null">
    <p><strong>Aceita agendar essa entrevista?</strong></p>
    <div class="action-buttons">
      <button mat-raised-button color="primary" style="margin-right: 5px" (click)="responder(true)">Aceitar</button>
      <button mat-raised-button color="warn" (click)="responder(false)">Rejeitar</button>
    </div>
  </ng-container>

  <ng-container *ngIf="data.points == 0 && data.accept !== null">
    <p [ngStyle]="{ color: data.accept == 1 ? '#2196f3' : '#e53935' }">
      {{ data.accept == 1 ? 'Agendou a entrevista' : 'Rejeitou a entrevista' }}
    </p>
  </ng-container>

  <p *ngIf="data.points > 0" style="color: #2e7d32; font-weight: bold;">
    Pontuação da entrevista: {{ data.points }}
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button color="accent" mat-button mat-dialog-close>Fechar</button>
</mat-dialog-actions>